import React from 'react';

interface ProgressBarProps {
  progress: number;
  current: number;
  total: number;
  darkMode?: boolean;
}

const ProgressBar: React.FC<ProgressBarProps> = ({ progress, current, total, darkMode = false }) => {
  return (
    <div className="mb-8">
      <div className="flex justify-between items-center mb-2">
        <span className={`font-semibold ${darkMode ? 'text-gray-200' : 'text-gray-800'}`}>Progress</span>
        <span className={`text-sm ${darkMode ? 'text-gray-300' : 'text-gray-600'}`}>
          {current} of {total} cards
        </span>
      </div>
      
      <div className={`w-full rounded-full h-3 overflow-hidden ${darkMode ? 'bg-gray-700' : 'bg-gray-200'}`}>
        <div 
          className="h-full bg-gradient-to-r from-tinder-pink to-tinder-orange rounded-full transition-all duration-500 ease-out"
          style={{ width: `${progress}%` }}
        ></div>
      </div>
      
      <div className="flex justify-between items-center mt-2">
        <span className={`text-xs opacity-75 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Start</span>
        <span className={`text-xs opacity-75 ${darkMode ? 'text-gray-400' : 'text-gray-500'}`}>Complete</span>
      </div>
    </div>
  );
};

export default ProgressBar;
